import { useEffect, useState } from "react";
import { api } from "./api/api";

const ALL_PERMISSIONS = [
  { code: "USERS_ADMIN", label: " Users Management" },
  { code: "MANIFEST_ENTRY", label: "Manifest Entry" },
  { code: "BOL_INVOICE", label: " BOL Invoice" },
  { code: "SERVICES_EDIT", label: " Services Edit" },
  { code: "MANIFEST_EDIT", label: "Manifest Edit" },
];

export default function UsersScreen() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [form, setForm] = useState({
    id: null,
    username: "",
    password: "",
    fullName: "",
    permissions: [],
  });

  const loadUsers = async () => {
    try {
      setLoading(true);
      const res = await api.get("/users"); // سنضيفه backend لو غير موجود
      setUsers(res);
    } catch {
      setMsg("Error loading users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const togglePerm = (code) => {
    setForm((prev) => ({
      ...prev,
      permissions: prev.permissions.includes(code)
        ? prev.permissions.filter((p) => p !== code)
        : [...prev.permissions, code],
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");

    try {
      if (form.id) {
        await api.put(`/users/${form.id}`, form);
        setMsg("User updated ✅");
      } else {
        await api.post("/users", form);
        setMsg("User added ✅");
      }

      setForm({
        id: null,
        username: "",
        password: "",
        fullName: "",
        permissions: [],
      });
      loadUsers();
    } catch (err) {
      setMsg(err.message || "Error saving user");
    }
  };

  const editUser = (u) => {
    setForm({
      id: u.id,
      username: u.username,
      password: "",
      fullName: u.full_name,
      permissions: u.permissions || [],
    });
  };

  const deleteUser = async (id) => {
    if (!window.confirm("do you really want to delete this user?")) return;
    try {
      await api.del(`/users/${id}`);
      loadUsers();
    } catch {
      setMsg("Error deleting user");
    }
  };

  return (
    <div className="screen">
      <h2> Users Management</h2>

      <form onSubmit={submit} className="card">
        <input
          placeholder="Username"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          disabled={!!form.id}
        />

        <input
          placeholder="Full name"
          value={form.fullName}
          onChange={(e) => setForm({ ...form, fullName: e.target.value })}
        />

        <input
          type="password"
          placeholder={form.id ? "New password (optional)" : "Password"}
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />
<div className="permissions-box">
  {ALL_PERMISSIONS.map((p) => {
    const checked = form.permissions.includes(p.code);
    return (
      <div
        key={p.code}
        className={`perm-item ${checked ? "checked" : ""}`}
        onClick={() => togglePerm(p.code)}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={() => togglePerm(p.code)}
        />
        <span className="perm-label">{p.label}</span>
      </div>
    );
  })}
</div>


        <button type="submit">
          {form.id ? "Update User" : "Add User"}
        </button>
      </form>

      {msg && <div className="message">{msg}</div>}

      <table className="data-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Name</th>
            <th>Permissions</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.username}</td>
              <td>{u.full_name}</td>
              <td>{(u.permissions || []).join(", ")}</td>
              <td>
                <button onClick={() => editUser(u)}>Edit</button>
                <button onClick={() => deleteUser(u.id)} className="danger-btn">
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
